'use strict';

var _jockey = require('@souche-f2e/jockey');

var _jockey2 = _interopRequireDefault(_jockey);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Promise = require('es6-promise').Promise;
// 界面相关，双向通信
module.exports = {
	/**
  * @desc 通过协议打开App原生界面
  * @param {String} agreement 协议内容
  * @param {Function} cb 回调函数(data 根据打开的页面返回不同的返回值)
  * 回调在模拟触发时会执行（设计双向通信内容）
  */
	openAppView: function openAppView(agreement, data, cb) {
		if (typeof data === "function") {
			cb = data;
			data = {};
		}
		_jockey2.default.send('OpenVCBridge', {
			protocol: agreement,
			data: data
		}, function (res) {
			cb && cb(res);
		});
	},

	/**
  * @desc 打开另一个页面并关闭当前页面
  * @param {String} agreement 协议内容
  * @param {Function} cb 回调函数
  */
	replaceAppView: function replaceAppView(agreement, data, cb) {
		if (typeof data === "function") {
			cb = data;
			data = {};
		}
		_jockey2.default.send('PopAndPushVCBridge', {
			protocol: agreement,
			data: data
		}, function (res) {
			cb && cb(res);
		});
	},

	/**
  * @desc 新打开一个webview
  * @param {String} url 页面url
  * @param {Function} cb 回调函数
  */
	openWebView: function openWebView(url, data, cb) {
		if (typeof data === "function") {
			cb = data;
			data = {};
		}
		_jockey2.default.send('PushWebVCBridge', {
			url: url,
			data: data
		}, function (res) {
			cb && cb(res);
		});
	},

	/**
  * @desc  双向通信，触发前一个页面的回调
  * @param {Object}   data    带给前一个页面的数据  可选 
  * @param {Function} cb      回调函数             可选
  *       回调数据：是否成功
  */
	triggerCallBack: function triggerCallBack(data) {
		if (typeof data === "undefined") {
			data = {};
		}
		return new Promise(function (resolve) {
			_jockey2.default.send("TriggleWebVCCallbackBridge", data, function (res) {
				resolve(res);
			});
		});
	},

	/**
  * @desc  双向通信，获取前面一个页面的数据
  * @param {Object}   data    带给前一个页面的数据  可选 
  * @param {Function} cb      回调函数             可选
  *       回调数据：是否成功
  */
	getWebVCData: function getWebVCData() {
		return new Promise(function (resolve) {
			_jockey2.default.send("GetWebVCDataBridge", function (data) {
				resolve(data);
			});
		});
	},

	/**
  * @desc 设置webview的Tag
  * @param {String} str 页面tag
  */
	setWebViewTag: function setWebViewTag(tag) {
		_jockey2.default.send('setWebViewTag', {
			tagStr: tag
		});
	},

	/**
  * @desc 打开特定tag的页面
  * @param {String} str 页面tag
  */
	openTagWebView: function openTagWebView(tag) {
		_jockey2.default.send('StackManager', {
			tagStr: tag
		});
	},

	/**
  * @desc 关闭当前WebView
  * @param 无
  */
	closeWebView: function closeWebView() {
		_jockey2.default.send("ControlWebVCBridge", {
			action: 'close'
		});
	},

	/**
  * @desc 控制webview属性
  * @param {String} params 接受多个字符串参数(最少为一个)
  *         'hideShare'      隐藏右边第二个按钮
  *         'ShowShare'      显示右边第二个按钮
  *         'hideBack'       隐藏返回按钮
  *         'showBack'       显示返回按钮
  *         'allowBounce'    允许回弹效果
  *         'forbidBounce'   禁止回弹的效果
  */
	controlWebView: function controlWebView() {
		for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
			params[_key] = arguments[_key];
		}

		for (var i = 0; i < params.length; i++) {
			_jockey2.default.send("ControlWebVCBridge", {
				action: params[i]
			});
		}
	},

	// webview显示的时候，执行方法
	attached: function attached(cb) {
		if (cb) {
			_jockey2.default.on('AppearAction', function () {
				cb();
			});
		} else {
			_jockey2.default.off('AppearAction');
		}
	},

	// webview隐藏的时候，执行方法
	detached: function detached(cb) {
		if (cb) {
			_jockey2.default.on('DisappearAction', function () {
				cb();
			});
		} else {
			_jockey2.default.off('DisappearAction');
		}
	},

	// 重新登录
	reLogin: function reLogin() {
		_jockey2.default.send('LogoutBridge');
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/@souche-f2e/chunyan-util/~/@souche-f2e/tower/lib/viewAndCommunicate.js
// module id = 272
// module chunks = 4